import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { CssBaseline, CircularProgress, Container, Button, Grid, Avatar, Accordion, AccordionSummary, AccordionDetails, Paper, Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import CustomizedSnackbars from '../../components/material-snackbars';
import * as CalledService from "../../services/called.service";
import CategoryIcon from '@mui/icons-material/Category';
import Api from '../../services/api';
import { browserHistory } from '../../helpers/history';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import * as OrgDepartamentService from '../../services/organizationdepartament.service';
import Dropzone from 'react-dropzone';
import moment from "moment";
import * as CalledOrganizationChecklistService from '../../services/calledorganizationchecklist.service'
import { QueuePlayNext, DeleteForever, ExpandMore } from "@mui/icons-material";
import If from '../../components/conditionals/if'
import DialogContentText from '@mui/material/DialogContentText';

import {
    TextField,
} from "@mui/material";
import { getDepartamentsByOrganizationCategoryIdNew, getCategoriesByOrganizationDepartamentId } from '../../services/organizationcategory.service';
import { AbilityContext } from '../../config/ability-context'
import { FormattedMessage, injectIntl } from 'react-intl';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PhoneIcon from '@mui/icons-material/Phone';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import ReactQuill, { Quill } from 'react-quill'; // ES6
import AttachFileIcon from '@mui/icons-material/AttachFile';

import { withRouter } from 'react-router-dom';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import SimpleCheckBox from '../../components/checkbox/check';
import SimpleAutoCompleteMultiple from '../../components/auto-complete/autocomplete-multiple-create';
import SimpleDatePickerRequired from '../../components/date-pickers/inline-required';
import RegexInput from 'src/components/regex-input/regex-input';
import * as componentActions from '../../redux/actions/organizationcategoriesportal';
import { PapiroConsole } from '../../utils/papiroConsole';
import ClearIcon from '@mui/icons-material/Clear';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete-categories';
import Search from '@mui/icons-material/Search';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import CardMedia from '@mui/material/CardMedia';
import organizationcategoryportal from '../../redux/reducers/organizationcategoryportal';
import Childrencardcategories from '../portal/components/childrencardcategories/childrencardcategories';
import Cardcategories from '../portal/components/cardcategories/cardcategories';
import ModalRating from "../../components/ModalRating";



class CardInformations extends Component {

    constructor(props) {
        super(props);

        const intl = this.props.intl;


        let fromProps = ""
        let organizationCategory = null


        this.reactQuillModules = {
            toolbar: [
                [{ 'header': [1, 2, false] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                ['link', 'image'],
                ['clean'],
            ],
        }

        this.reactQuillFormats = [
            'header',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet', 'indent',
            'link', 'image', 'color', 'font'
        ]

        const defaultvalue = { id: 0, name: "", parentname: "" };
        const { userSession } = this.props;

        if (userSession.user && userSession.user.organizationlistid) {
            this.userOrganizations = userSession.user.organizationlistid;
        }
        this.typingTimeout = null;
        this.initialCalledState = {
            // requestingUser: null,
            requestingUser: userSession.user.id,
            createdUser: userSession.user.id,
            organization: null,
            type: 0,
            CategoryId: defaultvalue,
            categoryText: "",
            dueDate: moment()
                .add("days", 1)
                .format("YYYY/MM/DD HH:mm:ss"),
            title: "",
            status: 0,
            description: "",
            AddressId: 0,
            originRequest: 9,
            observantUser: 0,
            assignedUser: 0,
            patrimonyId: "",
            departamentId: 0,

        }
        this.state = {
            informativeText: '',
            informativeTextAccordionExpanded: true,
            userOrganizations: this.userOrganizations,
            organizationAddressesList: [],
            urlImage: null,
            newCategoryDepartament: false,
            campoTexto: null,
            canselectorganizationcategoriesbylevels: false,
            organizationFieldList: [],
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            resultCategories: [],
            resultCategoriesOfPortal: [],
            files: [],
            organizationCategory: {
                id: 0,
                name: '',
                parentName: '',
                description: '',
                information: '',
                canCreateCalled: false,
                organizationId: 0,
                sla: 0,
            },
            called: this.initialCalledState,
            tabvalue: 0,
            calledInfoDialogOpen: false,
            calledInfoDialogId: 0,
            calledInfoDialogTitle: '',
            calledInfoDialogDueDate: '',
            modalRatingOpen: false,
            unratedCalledsList: [],
            openDialogNewAttendence: false,
            newAttendenceAccept: false,

            // selectRequesterDialog: false,
            // selectedCategory: null,
            // requesterOption: 'me',
            // selectedUser: null,
            // clientUsersList: [],
            // organizationList: [],
            // selectedOrganizationForRequester: null,
            // showNewUserForm: false,
            // loadingClientUsers: false,
            // createUserCalled: {
            //     nameOfNewUser: null,
            //     cpfOfNewUser: null,
            //     emailOfNewUser: null,
            //     confirmEmailOfNewUser: null
            // },
            // itemError: { document: '' },
            // OrganizationFilter: [],
            // selectOrganizations: false,
            // ratingModalProcessed: false,
            // ratingModalWasOpen: false,
            // associateOrganizationOptions: 'associateSelectedOrganization',
            // requestingUser: null,
            // requestingUserData: null,
            // createdAt: moment().format('YYYY/MM/DD HH:mm:ss'),
        };

        this.organizationId = null;
        this.userDepartamentId = 0;
        this.roleClientCanSelectCategory = false;
        this.canClientSelectPatrimonyInCalled = false;
        this.canClientSelectTypeInCalled = false;
        this.restrictviewcalleddepartament = false;
        this.canselectpatrimonyincalled = false;
        this.canselectdepartamentincalled = false
        this.isClient = true;
        this.globalAdm = false;
        this.modalRating = null;
        this.displayassignedinfomode = 0;
        this.requiredratingcalleds = false;
        this.userid = userSession.user.id;
        userSession.user.userrole.map((item, key) => {
            if (item.role.roletype != 3) {
                this.isClient = false;

            }
            if (item.role.roletype == 0) {
                this.globalAdm = true;
            }
        }
        );
        if (userSession.user.organizationdepartamentid && userSession.user.organizationdepartamentid > 0) {
            this.userDepartamentId = userSession.user.organizationdepartamentid;
        }

        this.moveToAnotherPage = this.moveToAnotherPage.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getImage = this.getImage.bind(this);
        this.getRootCategoriesByOrganization = this.getRootCategoriesByOrganization.bind(this);
        this.getCategoryChildrens = this.getCategoryChildrens.bind(this);
        this.getAllCategoryOfPortal = this.getAllCategoryOfPortal.bind(this);

        this.closeNotification = this.closeNotification.bind(this);
        this.handleChangeEditorDescription = this.handleChangeEditorDescription.bind(this);
        this.getOrganizationCategoryById = this.getOrganizationCategoryById.bind(this);
        this.getOrganizationCategoryByIdAndMoveToAnotherPage = this.getOrganizationCategoryByIdAndMoveToAnotherPage.bind(this);
        this.validateImagesAtachments = this.validateImagesAtachments.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.changeValues = this.changeValues.bind(this);
        this.changeValuesCheckbox = this.changeValuesCheckbox.bind(this);
        this.handleChangeRadio = this.handleChangeRadio.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.getOrganizationSettings = this.getOrganizationSettings.bind(this)
        this.getOrganizationAddresses = this.getOrganizationAddresses.bind(this)
        this.getDepartamentsByOrganizationCategoryId = this.getDepartamentsByOrganizationCategoryId.bind(this)
        this.getCategoryFields = this.getCategoryFields.bind(this);
        this.getCategoriesByOrganization = this.getCategoriesByOrganization.bind(this)
        this.getOrganizationDepartaments = this.getOrganizationDepartaments.bind(this);
        this.backHistory = this.backHistory.bind(this)
        this.closeCalledInfoDialog = this.closeCalledInfoDialog.bind(this)
        this.changeDueDateByOrganizationCagetoryMessage = this.changeDueDateByOrganizationCagetoryMessage.bind(this)
        this.handleChangeAccordion = this.handleChangeAccordion.bind(this)
        this.getUnratedCalleds = this.getUnratedCalleds.bind(this)
        this.setLoading = this.setLoading.bind(this)
        this.setMessage = this.setMessage.bind(this)
        this.getDueDate = this.getDueDate.bind(this)
   
        this.handleGetResponseCustomDefaultValue = this.handleGetResponseCustomDefaultValue.bind(this)
        // this.handleRequesterSelection = this.handleRequesterSelection.bind(this);
        // this.handleInputChangeNewUser = this.handleInputChangeNewUser.bind(this);
        // this.resetNewUserForm = this.resetNewUserForm.bind(this);
        // this.getClientsByOrganizationId = this.getClientsByOrganizationId.bind(this);

    }

    handleChangeAccordion = (accordion) => (event, isExpanded) => {
        if (accordion === "informative-text")
            this.setState({ informativeTextAccordionExpanded: isExpanded })
    }

    closeCalledInfoDialog = () => this.setState({ calledInfoDialogOpen: false, calledInfoDialogId: 0, calledInfoDialogTitle: '', calledInfoDialogDueDate: '' })


    openDialogNewAttendence = async () => {
        this.setState({ openDialogNewAttendence: !this.state.openDialogNewAttendence });
      }

    
    
    
    
    /*async componentWillReceiveProps(nextProps) {
        PapiroConsole.log("entrei aqui no componentWillReceiveProps ")
        PapiroConsole.log(nextProps)
        if (nextProps.location && nextProps.location.state && nextProps.location.state.action && nextProps.location.state.action === "cardReload") {
            await this.componentDidMount()
        }


    }*/

    componentDidUpdate(prevProps) {
        PapiroConsole.log("entrei aqui no didupdate")
        PapiroConsole.log(this.props.match.params.id)
        PapiroConsole.log(prevProps.match.params.id)
        if (this.props.match.params.id !== prevProps.match.params.id) {
          this.initializateData(this.props.match.params.id);
        }
      }

    async componentDidMount() {

        this.initializateData();

    }



    async initializateData() {

        
        
        const { organizationcategoryportal } = this.props;
        PapiroConsole.log("organizationcategoryportal")
        PapiroConsole.log(organizationcategoryportal)
        const { id } = this.props.match.params

        // this.setState({ 
        //     ratingModalProcessed: false,
        //     ratingModalWasOpen: false 
        // });
        

        PapiroConsole.log(id)
        PapiroConsole.log("id here")

        var elementId = organizationcategoryportal.organizationcategoryportal.id != null ? organizationcategoryportal.organizationcategoryportal.id : 0
        //var parentElementId =this.props.history && this.props.history.location && this.props.history.location.state && this.props.history.location.state.parentId != null ? this.props.history.location.state.parentId : 0
        PapiroConsole.log("checar if")
        PapiroConsole.log(id)
        PapiroConsole.log(elementId)

        if (id == elementId) {

            var checkCategory = true
            // função para checar se o cliente tem acesso a aquela categoria
            if (this.globalAdm == false) {
                checkCategory = await this.checkCategoryById(id)
            }

            if (checkCategory == true) {
                PapiroConsole.log("entrei no if")
                PapiroConsole.log(organizationcategoryportal)

                let { dueDate } = this.state.called;

                if (organizationcategoryportal.organizationcategoryportal.useslatime != null && organizationcategoryportal.organizationcategoryportal.useslatime) {
                    
                    dueDate = await this.getDueDate(organizationcategoryportal.organizationcategoryportal.id, organizationcategoryportal.organizationcategoryportal.organizationslaid);

                } else if (organizationcategoryportal.organizationcategoryportal.useslatime != null && !organizationcategoryportal.organizationcategoryportal.useslatime) {
                    if (organizationcategoryportal.organizationcategoryportal.solutiontime && organizationcategoryportal.organizationcategoryportal.solutiontime > 0) {
                        dueDate = moment().add(organizationcategoryportal.organizationcategoryportal.solutiontime, 'minutes').format("YYYY/MM/DD HH:mm:ss");                        
                    }
                }

                await this.setState(prevState => ({
                    called: {
                        ...prevState.called,
                        description: '',
                        dueDate: dueDate
                    },
                    organizationCategory: {
                        id: organizationcategoryportal.organizationcategoryportal ? organizationcategoryportal.organizationcategoryportal.id : 0,
                        name: organizationcategoryportal.organizationcategoryportal ? organizationcategoryportal.organizationcategoryportal.name : "",
                        parentName: organizationcategoryportal.organizationcategoryportal ? organizationcategoryportal.organizationcategoryportal.parentname : "",
                        description: organizationcategoryportal.organizationcategoryportal ? organizationcategoryportal.organizationcategoryportal.description : "",
                        information: organizationcategoryportal.organizationcategoryportal ? organizationcategoryportal.organizationcategoryportal.information : "",
                        canCreateCalled: organizationcategoryportal.organizationcategoryportal ? organizationcategoryportal.organizationcategoryportal.cancreatecalled : false,
                        organizationId: organizationcategoryportal.organizationcategoryportal ? organizationcategoryportal.organizationcategoryportal.organizationid : 0,
                        sla: organizationcategoryportal.organizationcategoryportal ? organizationcategoryportal.organizationcategoryportal.organizationslaid : 0,
                        type: organizationcategoryportal.organizationcategoryportal ? organizationcategoryportal.organizationcategoryportal.typeid : 0,
                        priorityId: organizationcategoryportal.organizationcategoryportal ? organizationcategoryportal.organizationcategoryportal.priorityid : 0
                    },
                }));

                this.organizationId = organizationcategoryportal.organizationcategoryportal ? organizationcategoryportal.organizationcategoryportal.organizationid : 0

                if (organizationcategoryportal.organizationcategoryportal != null && organizationcategoryportal.organizationcategoryportal.cancreatecalled != null && organizationcategoryportal.organizationcategoryportal.cancreatecalled) {
                    await this.getOrganizationSettings()
                    PapiroConsole.log("entrei aqui x vezes")
                    await this.getUnratedCalleds()
                }
                else
                    this.setState({ informativeText: "", informativeTextAccordionExpanded: true })
                //pegar categorias filhas
                await this.getCategoryChildrens(elementId)
                PapiroConsole.log("pegar categorias filhas")
                await this.getAllCategoryOfPortal()

                //pegar imagens das categorias
                if (organizationcategoryportal.organizationcategoryportal && organizationcategoryportal.organizationcategoryportal.attachmentid) {

                    await this.getImage(organizationcategoryportal.organizationcategoryportal.attachmentid);
                }
                else {
                    this.setState({
                        urlImage: null
                    })
                }
                //checando se pode criar chamado e não tem categorias filhas
                if (this.state.organizationCategory.canCreateCalled == true && this.state.resultCategories.length == 0) {
                    await this.getOrganizationAddresses()
                    //await this.getDepartamentsByOrganizationCategoryId(this.state.organizationCategory.id)
                    await this.getCategoryFields(this.state.organizationCategory.id)

                    // if (!this.isClient) {
                    //     await this.getOrganizations();
                    //     if (!this.state.ratingModalWasOpen) {
                    //         this.tryToOpenRequesterModal();
                    //     }
                    // } else {
                    //     const { userSession } = this.props;
                    //     this.state.requestingUser = userSession.user.id;
                    // }
                }
            }
        }
        else {
            PapiroConsole.log("entrei no else")
            PapiroConsole.log("id do else")
            PapiroConsole.log(id)
            await this.getOrganizationCategoryById(id)
        }
    }

    checkCategoryById = async (id) => {

        this.setState({ loading: true })
        var getResult = false
        await Api.get(`/organizationcategories/checkifcanaccesscategory?org=${this.state.userOrganizations}&categoryid=${id}&`)
            .then(async result => {

                if (result.data.success) {
                    PapiroConsole.log(result)
                    PapiroConsole.log(result.data.data.length)

                    if (result.data.data && result.data.data.length != 0) {
                        PapiroConsole.log("entrei aqui no if certo")
                        getResult = true

                    }

                    this.setState({ loading: false })

                }

            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
                else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage: intl.formatMessage({ id: "process.error" })
                    });
                }




            });


        if (getResult == false) {
            this.setState({
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: "O usuário não tem acesso a esta categoria ou ela não está configurada para aparecer no portal"
            });

        }
        return getResult
    }

    async getOrganizationFields(organizationId) {
        if (organizationId == null) {

            return null;
        }
        if (!this.isClient) {
            var result = await CalledOrganizationChecklistService.getActiveOrganizationFieldsByOrganizationAndCategories(organizationId);
        }
        else {
            result = await CalledOrganizationChecklistService.getActiveOrganizationFieldsByOrganizationCustomerEdit(organizationId);
        }


        if (result.success) {

            this.setState({ organizationFieldList: result.data?.length > 0 ? result.data : []});


            Object.keys(this.state.called).forEach((key) => {

                if (key.includes("ofield-")) {
                    this.setState(prevState => ({
                        called: {
                            ...prevState.called,
                            [key]: undefined

                        }
                    }))
                }

            })

            if (result.data) {


                result.data.forEach(element => {

                    if (element.organizationfieldtype == 3) {
                        const value = this.handleGetResponseCustomDefaultValue(element);

                        this.setState(prevState => ({
                            called: {
                                ...prevState.called,
                                ['ofield-' + element.id]: value

                            }
                        }))
                    } 
                    else if (element.organizationfieldtype == 9) {
                        const value = this.handleGetResponseCustomDefaultValue(element);

                        this.setState(prevState => {
                            const key = 'ofield-' + element.id;
                            return {
                                called: {
                                    ...prevState.called,
                                    [key]: value
                                }
                            }
                        })
                    } 
                    else {
                        this.setState(prevState => ({
                            called: {
                                ...prevState.called,
                                ['ofield-' + element.id]: ""

                            }
                        }))
                    }



                });

                this.returnFields();

            }
            //this.returnFields();
        } else {
            const intl = this.props.intl;
            this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);

        }
    };
    async getCategoryFields(organizationCategoryId) {


        if (this.isClient) {
            var result = await CalledOrganizationChecklistService.GetByOrganizationCategoryIdAndActiveCustomerEdit(organizationCategoryId);
        }
        else {

            var result = await CalledOrganizationChecklistService.GetByOrganizationCategoryIdAndActive(organizationCategoryId);
        }


        if (result.success) {

            if (result.data.length > 0) {

                this.setState({ organizationFieldList: result.data?.length > 0 ? result.data : [] });
                Object.keys(this.state.called).forEach((key) => {

                    if (key.includes("ofield-")) {
                        this.setState(prevState => ({
                            called: {
                                ...prevState.called,
                                [key]: undefined

                            }
                        }))
                    }
                })

                if (result.data) {

                    result.data.forEach(element => {

                        if (element.organizationfieldtype == 3) {
                            const value = this.handleGetResponseCustomDefaultValue(element);


                            this.setState(prevState => ({
                                called: {
                                    ...prevState.called,
                                    ['ofield-' + element.id]: value

                                }
                            }))
                        }
                        else if (element.organizationfieldtype == 9) {
                            const value = this.handleGetResponseCustomDefaultValue(element);

                            this.setState(prevState => {
                                const key = 'ofield-' + element.id;
                                return {
                                    called: {
                                        ...prevState.called,
                                        [key]: value
                                    }
                                }
                            })
                        } 
                        else {
                            this.setState(prevState => ({
                                called: {
                                    ...prevState.called,
                                    ['ofield-' + element.id]: ""

                                }
                            }))
                        }



                    });

                    this.returnFields();

                }

            } else {

                this.getOrganizationFields(this.organizationId)
            }




            //this.returnFields();*/



        } else {
            const intl = this.props.intl;
            this.setState({
                loading: false, openNotification: true, notificationVariant: "error",
                notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);

        }
    };

    handleGetResponseCustomDefaultValue = (organizationfield) => {
        const organizationfieldtype = organizationfield?.organizationfieldtype ?? null;
        const defaultvalue = organizationfield?.defaultvalue ?? null;

        if (!organizationfieldtype || !defaultvalue) return "";

        switch (organizationfieldtype) {
            case 3:
                return defaultvalue === "true";
            case 9:
                if (defaultvalue.toString().indexOf("customdate§") === 0) {
                    const parts = defaultvalue.split("§");
                    if (parts.length === 2) {
                        const customDate = parts[1];

                        const date = moment(customDate);

                        const validDate = date.isValid() ? customDate : "";

                        return validDate;
                    }
                }
                if (defaultvalue.toString().indexOf("currentdate") === 0) {
                    return new Date()
                }

                return "";

            default:
                return "";
        }
    }

    getDepartamentsByOrganizationCategoryId = async (id) => {

        var result = await getDepartamentsByOrganizationCategoryIdNew(id);
        if (result.success) {
            if (result.data && result.data.length > 0) {
                if (this.restrictviewcalleddepartament === true && this.state.userDepartamentId && this.state.userDepartamentId.id && this.state.userDepartamentId.id > 0) {

                    var updatedList = result.data.filter(item => item.id == this.state.userDepartamentId.id)
                    if (updatedList)
                        updatedList = updatedList[0]

                    if (result.data.length == 1) {
                        this.setState(prevState => ({
                            called: {
                                ...prevState.called,
                                departamentId: result.data[0]
                            }
                        }))
                    }

                    this.setState({ loading: false, DepartamentList: [updatedList] });
                } else {

                    if (this.state.called.departamentId && this.state.called.departamentId.id) {

                        var updatedList = result.data.filter(item => item.id == this.state.called.departamentId.id)
                        if (updatedList)
                            updatedList = updatedList[0]

                        if (result.data.length == 1) {
                            this.setState(prevState => ({
                                called: {
                                    ...prevState,
                                    departamentId: result.data[0]
                                }
                            }))
                        }

                        this.setState({ loading: false, DepartamentList: updatedList && updatedList.length > 1 ? updatedList.sort((a, b) => a.name.localeCompare(b.name)) : updatedList });
                    } else {

                        this.setState({ loading: false, DepartamentList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });
                    }
                }
                this.setState({ newCategoryDepartament: false })
            } else {

                this.getOrganizationDepartaments(this.organizationId)
            }
        } else {
            const intl = this.props.intl;
            this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);
        }
    }

    getOrganizationDepartaments = async (id) => {
        const { userSession } = this.props;

        //this.setState({ loading: true });

        var result = await OrgDepartamentService.getOrganizationsDepartaments(id);
        if (result.success) {
            if (this.state.called.departamentId && this.state.called.departamentId.id) {
                var updatedList = result.data.filter(item => item.id == this.state.called.departamentId.id)

                this.setState({
                    DepartamentList: updatedList.length > 0 ? (updatedListAtt && updatedListAtt.length > 1 ? updatedListAtt.sort((a, b) => a.name.localeCompare(b.name)) : updatedListAtt) : (result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data),
                    newCategoryDepartament: true
                });
            } else {
                let userDepartaments = this.state.userDepartamentId

                if (userDepartaments != null) {
                    var updatedListAtt = result.data.filter(item => item.id == userDepartaments.id)

                    this.setState({
                        DepartamentList: updatedListAtt.length > 0 ? (updatedListAtt && updatedListAtt.length > 1 ? updatedListAtt.sort((a, b) => a.name.localeCompare(b.name)) : updatedListAtt) : (result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data),
                        newCategoryDepartament: true
                    }, () => {
                        if (updatedListAtt.length > 0) {
                            this.setState(prevState => ({
                                called: {
                                    ...prevState.called,
                                    departamentId: updatedListAtt[0]
                                }
                            }))
                        }
                    });
                } else {
                    this.setState({
                        DepartamentList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data,
                        newCategoryDepartament: true
                    });
                }
            }
        } else {
            const intl = this.props.intl;
            this.setState({
                newCategoryDepartament: false,
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);
        }
    }


    async getOrganizationSettings() {
        let infos;
        let categoryLevel = false
        await Api.get(`/organizationsettings/organizations/${this.state.organizationCategory.organizationId}`)
            .then((result) => {
                if (result.data.success && result.data.data.length > 0) {
                    const resultData = result.data.data[0];

                    infos = resultData;

                    this.requiredratingcalleds = resultData.requiredratingcalleds
                    this.canselectpatrimonyincalled = resultData.canselectpatrimonyincalled;
                    this.canselectdepartamentincalled = resultData.canselectdepartamentincalled
                    this.roleClientCanSelectCategory = resultData.roleclientcanselectcategory;
                    this.canClientSelectPatrimonyInCalled = resultData.canclientselectpatrimonyincalled;
                    this.canClientSelectTypeInCalled = resultData.canclientselecttypeincalled;
                    this.restrictviewcalleddepartament = resultData.restrictviewcalleddepartament
                    this.displayassignedinfomode = resultData.displayassignedinfomode
                    categoryLevel = resultData.canselectorganizationcategoriesbylevels
                    this.setState(prevState => ({
                        canselectorganizationcategoriesbylevels: resultData.canselectorganizationcategoriesbylevels,
                        informativeText: resultData.informativetext != null ? resultData.informativetext : "",
                        informativeTextAccordionExpanded: true,
                        organizationCategory: {
                            ...prevState.organizationCategory,
                            type: resultData.type.id
                        }
                    }))
                }
            })
            .catch((err) => {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response && err.response.data && err.response.data.errors
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });

            });
        /* if (this.organizationId && this.organizationId > 0) {
             if (categoryLevel === true)
                 await this.getRootCategoriesByOrganization(this.organizationId);
             else
                 await this.getCategoriesByOrganization(this.organizationId)
         }*/
        return infos;
    }

    getCategoriesByOrganization = async (organizationId) => {

        if (organizationId == null) {

            return null;
        }

        const { userSession } = this.props;

        if (this.restrictviewcalleddepartament === true && this.state.userDepartamentId && this.state.userDepartamentId.id) {

            var result = await getCategoriesByOrganizationDepartamentId(this.state.userDepartamentId.id)
            if (result.success) {
                this.setState({ categoriesList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });

            } else {
                const intl = this.props.intl;
                this.setState({

                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response && result.response.data && result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });

            }
        } else {
            var result = await CalledService.getCategoriesByOrganization(
                organizationId
            );

            if (result.success) {
                this.setState({ categoriesList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });

            } else {
                const intl = this.props.intl;
                this.setState({

                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response && result.response.data && result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });

            }
        }
    }

    getRootCategoriesByOrganization = async (organizationId) => {
        const intl = this.props.intl;
        var result = await CalledService.getRootCategoriesByOrganization(organizationId);
        if (result.success) {
            if (this.isTec == false) {
                if (result.data.length < 1 && organizationId.toString().indexOf(",") == -1) {
                    if (this.AdmOrganization) {
                        const intl = this.props.intl;
                        this.setState({
                            openNotification: true, notificationVariant: "error",
                            notificationMessage: intl.formatMessage({ id: "called.accompaniment.notification.missing.organization.categories" }),
                            notificationLinkMove: "organizationcategories"
                        });
                    } else {
                        const intl = this.props.intl;
                        this.setState({
                            openNotification: true, notificationVariant: "error",
                            notificationMessage: intl.formatMessage({ id: "called.accompaniment.notification.missing.organization.categories" })
                        });
                    }
                }
            }
            this.setState({
                levelCategories: {
                    rootCategoriesList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data
                },
                categoryLists: [
                    result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data
                ]
            });
        } else {
            const intl = this.props.intl;
            this.setState({
                loading: false, openNotification: true, notificationVariant: "error",
                notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);
        }
    };

    getOrganizationAddresses = async () => {

        const result = await CalledService.getOrganizationAddresses(
            this.state.organizationCategory.organizationId
        );

        if (result.success) {
            this.setState({ organizationAddressesList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });

            if (result.data && result.data.length == 1) {
                this.setState(prevState => ({
                    called: {
                        ...prevState.called,
                        AddressId: result.data[0]
                    },
                }))
            }

            else if (result.data && result.data.length > 1) {
                var getLocation = null

                result.data.forEach(element => {
                    if (element.defaultlocation) {
                        getLocation = element
                    }
                });

                if (getLocation != null) {
                    this.setState(prevState => ({
                        called: {
                            ...prevState.called,
                            AddressId: getLocation
                        },
                    }))
                }
                else {
                    this.setState(prevState => ({
                        called: {
                            ...prevState.called,
                            AddressId: result.data[0]
                        },
                    }))
                }
            }
            else {
                this.setState({

                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: "É necessária ter uma localização associada a organização"
                });
            }



        } else {
            if (result.response) {
                const intl = this.props.intl;
                this.setState({

                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
            } else {
                const intl = this.props.intl;
                this.setState({

                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : "Erro ao processar a solicitação: " + result.response,
                });
            }

        }
    }

    getDueDate = async (organizationCategoryId, slaId) => {
        const { intl } = this.props;
        const { dueDate } = this.state.called;
    
        let initDate = dueDate;
    
        // Primeiro tenta usar o SLA da organização se disponível
        if (slaId && slaId > 0) {
          try {
            const result = await CalledService.calculateEstimateResolution(organizationCategoryId, slaId);
            
            if (result?.success) {
              // Se tiver dados do cálculo de SLA, usa eles
              if (result.data?.length > 0) {
                return result.data;
              }
            } else {
              this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: result.response?.data?.errors?.[0] || intl.formatMessage({ id: "process.error" })
              });
              Api.kickoff(result);
            }
          } catch (error) {
            console.error('Erro ao calcular estimativa de resolução:', error);
          }
        }
    
        return initDate;
      }

      handleSubmitAccept = async (e) => {
        await this.setState({ newAttendenceAccept: true });
        this.handleSubmit(e);
      }

    handleSubmit = async e => {
        e.preventDefault();

        if (document.body.innerHTML.includes("O campo é inválido para o formato definido, verifique antes de continuar.")) {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: "Existem campos com erros de validação. Por favor, verifique antes de continuar."
            });
            return;
        }

        // if (!this.isClient && !this.state.requestingUser) {
        //     this.tryToOpenRequesterModal();
        //     return;
        // }

        this.setState({ loading: true });


        let data = new FormData();

        data.append("organization", this.state.organizationCategory.organizationId);
        const clientInfos = await this.getOrganizationSettings();

        // if (!this.isClient && this.state.requestingUser) {
        //     data.append("requestingUser", this.state.requestingUser);
        // } else {
        //     data.append("requestingUser", this.props.userSession.user.id);
        // }

        PapiroConsole.log(clientInfos)
        PapiroConsole.log("clientInfos aqui")

        if (clientInfos) {
            //console.log(clientInfos);
            this.setState((prevState) => ({
                called: {
                    ...prevState.called,
                    originRequest: 9,
                    sla: this.state.organizationCategory.sla,
                    status: clientInfos.status ? clientInfos.status.id : 1,
                    type: this.state.organizationCategory.type != 0 ? this.state.organizationCategory.type : clientInfos.type && clientInfos.type.id ? clientInfos.type.id : 0,
                    OrganizationCategory: this.state.organizationCategory.id
                        ? this.state.organizationCategory.id
                        : 0,
                    priorityId: 
                    this.state.organizationCategory.priorityId != 0 
                    ? this.state.organizationCategory.priorityId 
                    : clientInfos.priority && clientInfos.priority.id != 0 
                    ? clientInfos.priority.id 
                    : 1
                },
                loading: true
            }));

            if (clientInfos.techinicalteam && clientInfos.techinicalteam.id && clientInfos.techinicalteam.id > 0)
                data.append("techinicalTeamId", clientInfos.techinicalteam.id)

            this.state.files.forEach((file) => data.append("filesUpload", file));
            let calledOrganizationFieldList = []

            for (let key in this.state.called) {
                if (key === "dueDate") {
                    const dueDate = this.state.called[key];
                    
                    data.append(
                        key,
                        dueDate
                    );
                } else if (
                    key
                        .toString()
                        .toLowerCase()
                        .indexOf("categoryid") > -1
                    && this.state.called[key]
                ) {
                    data.append("Category", this.state.called[key].id);
                } else if (key.toString().toLowerCase().indexOf('addressid') > -1) {
                    if (this.state.called[key].id) {
                        if (!isNaN(this.state.called[key].id)) {
                            data.append("AddressId", this.state.called[key].id);
                        }
                        else {
                            data.append("AddressId", 0);
                        }
                    } else {
                        data.append("AddressId", 0);
                    }
                } else if (key.toString().toLowerCase().indexOf('departamentid') > -1) {
                    let deptVal = this.state.called[key].id
                    if (deptVal == null || typeof deptVal === 'undefined')
                        deptVal = 0
                    data.append("OrganizationDepartamentId", deptVal);
                } else if (key.toString().toLowerCase().indexOf('assigneduser') > -1) {
                    if (clientInfos.defaulttechinicalid) {
                      data.append("assignedUser", clientInfos.defaulttechinicalid)
                    }
                  } else {
                    if (key.toString().toLowerCase().indexOf("ofield-") > -1) {
                        calledOrganizationFieldList.push(this.state.called.key)
                    } else
                        data.append(key, this.state.called[key]);
                }
            }

            let list = this.state.called["patrimonyId"];

            if (list != null && list != "") {
                let result = "";

                for (let value in this.state.called["patrimonyId"]) {
                    result = this.state.called["patrimonyId"][value].id + "," + result;
                }

                data.append("calledOrganizationPatrimonyId", result);
            }
            if (this.isClient == true) {
                data.append("isClientCreator", true);
            }
            else {
                data.append("isClientCreator", false);
            }

            if(this.state.newAttendenceAccept){
                data.append("acceptNewAttendence", true);
                this.setState({ newAttendenceAccept: false });
            }

            data.append("newCategoryDepartament", this.state.newCategoryDepartament)
            //data.append("priorityid", 1)

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            };

            Object.keys(this.state.called).forEach((key) => {
                if (key.includes("ofield-") && this.state.called[key] != undefined && this.state.called[key] != null) {

                    if (typeof this.state.called[key] == "boolean") {
                        this.state.called[key] = this.state.called[key].toString()

                    }

                    if (this.state.called[key] instanceof Date) {
                        this.state.called[key] = this.state.called[key].toISOString().split("T")[0];
                    }
                    let organizationFieldOptionsValuesId
                    let explode = key.split('-')
                    let explode2 = this.state.called[key].toString().split('\n')
                    let val = explode2[0]

                    let organizationFieldId = explode[1];
                    if (explode2[1] == undefined) {
                        organizationFieldOptionsValuesId = 0;
                    }
                    else {
                        organizationFieldOptionsValuesId = explode2[1];
                    }



                    data.append("OrgFieldIdsList", parseInt(organizationFieldId))
                    data.append("OrgFieldValuesList", val)

                    data.append("OrgFieldOptionsValuesList", organizationFieldOptionsValuesId)
                }
            })

            if(window && window.location &&  window.location.href){
                const currentURL = window.location.href;
                data.append('absoluteOrigin', currentURL)
              }



            Api.post("/calleds", data, config)
                .then((result) => {
                    if (result.data.success) {
                        if (result.data.data != null) {
                            this.setState({
                                calledInfoDialogId: result.data.data.id,
                                calledInfoDialogTitle: result.data.data.title,
                                calledInfoDialogDueDate: result.data.data.duedate ? moment(result.data.data.duedate).format("DD/MM/YYYY") : '',
                                calledInfoDialogOpen: true
                            })
                        }
                        // this.resetNewUserForm();
                        PapiroConsole.log("entrei erro 2")
                        const intl = this.props.intl;
                        this.setState({
                            loading: false,
                            openNotification: true,
                            notificationVariant: "success",
                            notificationMessage: intl.formatMessage({ id: "add.success" }),
                            called: this.initialCalledState,
                            files: [],
                            disabledSaveButton: false,
                            campoTexto: null,
                            organizationFieldList: [],
                            openDialogNewAttendence: false,
                        });
                        this.componentDidMount()
                    }
                })
                .catch((err) => {

                    PapiroConsole.log("entrei erro 1")
                    if(!isNaN(err.response.data.errors[0])){
                        if(err.response.data.errors[0] == 5){
                          this.setState({
                            loading: false,
                            openDialogNewDisk: true,
                            valueNewDisk: err.response.data.errors[0],
                          });
                        }else{
                          this.setState({
                            loading: false,
                            openDialogNewAttendence: true,
                            valueNewAttendence: err.response.data.errors[0],
                          });
                        }
                        
          
                    } else{
                        const intl = this.props.intl;
                    this.setState({
                        disabledSaveButton: false,
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            err.response && err.response.data && err.response.data.errors
                                ? err.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    });
                    }
                    
                });
        } else {
            PapiroConsole.log("entrei erro 2")
            PapiroConsole.log()
            const intl = this.props.intl;
            this.setState({
                disabledSaveButton: false,
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "called.registration.client.organization.no.config.contact.admin" }),
            });
        }

    };                

    changeDueDateByOrganizationCagetoryMessage = (type, date) => {
        const intl = this.props.intl;

        switch (type) {
            case 1:
                this.setState({
                    openNotification: true,
                    notificationVariant: "info",
                    notificationMessage: intl.formatMessage({ id: "called.registration.notification.date.changed.sla.category" })
                });
                break;
            case 2:
                this.setState({
                    openNotification: true,
                    notificationVariant: "info",
                    notificationMessage: intl.formatMessage({ id: "called.registration.notification.date.changed.sla.category" })
                });
                break;
            default:
                break;
        }
    }

    handleChangeRadio = async (e) => {


        let value = e.target.value
        let name = e.target.name


        this.setState(prevState => ({
            called: {
                ...prevState.called,
                [name]: value
            }
        }))

        /*this.setState(prevState => ({
          radioChoice: {
            [name]: value
          }
        }))*/

    }

    returnFields() {
        var campoTexto = []
        var arrayseleção = []
        var fieldType = 0

        PapiroConsole.log("lista aqui")
        PapiroConsole.log(this.state.organizationFieldList)

        if (this.state.organizationFieldList.length > 0) {
            this.state.organizationFieldList.forEach(element => {
                fieldType = element.organizationfieldtype

                if (element.organizationfieldoptionsvalues.length > 0) {
                    element.organizationfieldoptionsvalues.forEach(element2 => {

                        if (fieldType == 2 || fieldType == 4 || fieldType == 6) {
                            arrayseleção.push(element2)
                        }

                    });

                    if (fieldType == 2) {

                        campoTexto.push(
                            <Grid item xs={6} sm={6}>
                                <FormControl required={element.isrequired}>
                                    <FormLabel id="demo-radio-buttons-group-label">{element.name}</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        name="radio-buttons-group"
                                    >
                                        {arrayseleção.map(item =>
                                            <FormControlLabel name={'ofield-' + element.id} value={item.name + '\n' + item.id} stateName={'ofield-' + element.name} onChange={this.handleChangeRadio} control={<Radio required={element.isrequired} />} label={item.name} />
                                        )}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        )

                        arrayseleção = []
                    }

                    if (fieldType == 4) {

                        campoTexto.push(
                            <Grid item xs={6} sm={6}>
                                <Tooltip title={element.name} placement="top-start" arrow>
                                    <div>
                                        <SimpleAutoComplete label={element.name} options={arrayseleção} stateName={'ofield-' + element.id} changeSelect={this.changeValues} required={element.isrequired} />
                                    </div>
                                </Tooltip>
                            </Grid>
                        )

                        arrayseleção = []
                    }

                    if (fieldType == 6) {

                        campoTexto.push(
                            <Grid item xs={6}>
                                <Tooltip title={element.name} placement="top-start" arrow>
                                    <div>
                                        <SimpleAutoCompleteMultiple
                                            required={element.isrequired}
                                            label={element.name}
                                            options={arrayseleção}
                                            stateName={"ofield-" + element.id}
                                            changeSelect={(stateName, value) => {
                                                const valueIds = value?.map(v => v.id).join(",") || [];

                                                this.setState(prevState => ({
                                                    called: {
                                                        ...prevState.called,
                                                        [stateName]: valueIds
                                                    }
                                                }));
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                            </Grid>
                        );

                        arrayseleção = []
                    }

                    if (fieldType == 10) {
                        const regex = element.organizationfieldoptionsvalues.length > 0 ? element.organizationfieldoptionsvalues[0].name : '';

                        campoTexto.push(
                            <Grid item xs={12}>
                                <Tooltip title={element.name} placement="top-start" arrow>
                                    <div>
                                        <RegexInput
                                            id={"ofield-" + element.id}
                                            name={"ofield-" + element.id}
                                            className="regex-input"
                                            label={element.name}
                                            regex={regex}
                                            onChangeValue={this.handleInputChange}
                                            required={element.isrequired}
                                        />
                                    </div>
                                </Tooltip>
                            </Grid>
                        );
                    }

                } else {

                    if (fieldType == 1) {

                        campoTexto.push(
                            <Grid item xs={6} sm={6}>
                                <Tooltip title={element.name} placement="top-start" arrow>
                                    <TextField
                                        autoComplete="fname"
                                        name={'ofield-' + element.id}
                                        variant="outlined"
                                        id={'ofield-' + element.id}
                                        label={element.name}
                                        fullWidth
                                        onChange={this.handleInputChange}
                                        inputProps={{ maxLength: 250 }}
                                        required={element.isrequired}
                                    />
                                </Tooltip>
                            </Grid>
                        )
                    }

                    if (fieldType == 3) {

                        campoTexto.push(
                            <Grid item xs={6} sm={6}>
                                <SimpleCheckBox
                                    selected={this.state?.called?.['ofield-' + element.id] || false}
                                    label={element.name}
                                    name={'ofield-' + element.id}
                                    stateName={'ofield-' + element.id}
                                    changeSelect={this.changeValuesCheckbox}
                                />
                            </Grid>
                        )
                    }

                    if (fieldType == 5) {
                        campoTexto.push(
                            <Grid item xs={6}>
                                <Tooltip title={element.name} placement="top-start" arrow>
                                    <TextField
                                        type="text"
                                        autoComplete="off"
                                        name={"ofield-" + element.id}
                                        variant="outlined"
                                        id={"ofield-" + element.id}
                                        label={element.name}
                                        fullWidth
                                        required={element.isrequired}
                                        inputProps={{
                                            inputMode: 'numeric',
                                            pattern: '[0-9]*',
                                            maxLength: element.maxlength || 250,
                                        }}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const numericValue = value.replace(/\D/g, '');

                                            if (numericValue.length <= (element.maxlength || 250)) {
                                                e.target.value = numericValue;
                                                this.handleInputChange(e);
                                            }
                                        }}
                                    />
                                </Tooltip>
                            </Grid>
                        );
                    }

                    if (fieldType == 7) {
                        campoTexto.push(
                            <Grid item xs={12}>
                                <Tooltip title={element.name} placement="top-start" arrow>
                                    <TextField
                                        autoComplete="fname"
                                        name={"ofield-" + element.id}
                                        variant="outlined"
                                        id={"ofield-" + element.id}
                                        label={element.name}
                                        fullWidth
                                        multiline
                                        rows={element.maxlength}
                                        onChange={this.handleInputChange}
                                        required={element.isrequired}
                                    />
                                </Tooltip>
                            </Grid>
                        );
                    }

                    if (fieldType == 8) {
                        campoTexto.push(
                            <Grid item xs={6}>
                                <Tooltip title={element.name} placement="top-start" arrow>
                                    <TextField
                                        type="text"
                                        autoComplete="off"
                                        name={"ofield-" + element.id}
                                        variant="outlined"
                                        id={"ofield-" + element.id}
                                        label={element.name}
                                        fullWidth
                                        required={element.isrequired}
                                        inputProps={{
                                            inputMode: 'decimal',
                                            pattern: '^[0-9]*[.,]?[0-9]*$',
                                            maxLength: element.maxlength || 250
                                        }}
                                        onChange={(e) => {
                                            let value = e.target.value.replace(',', '.');
                                            const numericValue = value.replace(/[^0-9.]/g, '');

                                            if (numericValue.length <= (element.maxlength || 250)) {
                                                e.target.value = numericValue;
                                                this.handleInputChange(e);
                                            }
                                        }}
                                    />
                                </Tooltip>
                            </Grid>
                        );
                    }

                    if (fieldType == 9) {
                        const key = 'ofield-' + element.id;
                        const getValue = this.state?.called?.[key] ? this.state?.called?.[key] : null;

                        campoTexto.push(
                            <Grid item xs={6}>
                                <SimpleDatePickerRequired
                                    currentDate={getValue}
                                    label={element.name}
                                    stateName={key}
                                    changeDate={(stateName, value) => {
                                        this.setState(prevState => ({
                                            called: {
                                                ...prevState.called,
                                                [stateName]: value
                                            }
                                        }));
                                    }}
                                    required={element.isrequired}
                                    toolTipTitle={element.name}
                                />
                            </Grid>
                        );
                    }
                }
            });
        }

        this.setState({ campoTexto: campoTexto });
    }

    changeValues = async (stateName, value, text = "") => {
        this.setState({
            loading: true,
        });

        if (stateName === 'searchCategories') {
            if (value.id != 0) {
                await this.setState(prevState => ({
                    called: {
                        ...prevState.called,
                        [stateName]: { id: 0, name: '' }
                    }
                }));
                await this.moveToAnotherPage(value, this.state.organizationCategory.id)
            }

        } else 
        if (stateName.includes("ofield")) {

            this.setState(prevState => ({
                called: {
                    ...prevState.called,
                    [stateName]: value.name + '\n' + value.id
                }
            }));
        } // else if(stateName === "organizationForRequester"){
        //     this.setState({ selectedOrganizationForRequester: value, selectedUser: null, clientUsersList: [], loadingClientUsers: true }, async () => {
        //         await this.getClientsByOrganizationId(value.id);
        //         this.setState({ loadingClientUsers: false });
        //     });
        // } else if (stateName === "selectedUser") {
        //     this.setState({ selectedUser: value });
        // } else if (stateName == 'selectOrganizations') {
        //     if (value == true) {
        //         this.setState({
        //             OrganizationFilter : [...this.state.organizationList]
        //         })
        //     } else {
        //         this.setState({
        //             OrganizationFilter : []
        //         })                
        //     }
        // }
        else {
            this.setState((prevState) => ({
                called: {
                    ...prevState.called,
                    [stateName]: value,
                },
            }));
        }





        this.setState({
            loading: false,
        });
    }



    async changeValuesCheckbox(stateName, value, text = '') {




        if (stateName.includes("ofield")) {

            this.setState(prevState => ({
                called: {
                    ...prevState.called,
                    [stateName]: value
                }
            }));


        }

    };



    handleInputChange(e) {
        const name = e.target.name;
        const value = e.target.value;

        this.setState((prevState) => ({
            called: {
                ...prevState.called,
                [name]: value,
            },
        }));
    }

    removeItem(file) {
        let array = [...this.state.files];
        let index = array.indexOf(file)
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ files: array });
        }
    }

    async backHistory() {



        if (this.fromProps) {
            await this.props.history.push(`/${this.props.match.params.lang}/portal`)
        }
        else {
            //await browserHistory.goBack()
            if (this.props.location && this.props.location.state && this.props.location.state.parentId) {

                await this.getOrganizationCategoryByIdAndMoveToAnotherPage(this.props.location.state.parentId)
            }
            else {
                await this.props.history.push(`/${this.props.match.params.lang}/portal`)
            }


        }

    }

    validateImagesAtachments(files) {


        const intl = this.props.intl;
        if (files.length > 1) {
            this.setState({
                evAttachFile: {},
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "checklist.modal.select.image.error" }),
            })
            return
        }
        else {
            this.setState({ files: files })
        }

    }

    async getOrganizationCategoryById(id) {


        this.setState({ loading: true })
        await Api.get(`/organizationcategories/withoutparents/${id}`)
            .then(async result => {


                if (result.data.success) {
                    await this.props.addCurrent(result.data.data)
                    this.setState({ loading: false })
                    await this.componentDidMount();
                }


            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
                else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage: intl.formatMessage({ id: "process.error" })
                    });
                }


            });



    }

    async getOrganizationCategoryByIdAndMoveToAnotherPage(id) {

        console.log("entrei nessa função")

        var checkCategory = true
        // função para checar se o cliente tem acesso a aquela categoria
        if (this.globalAdm == false) {
            checkCategory = await this.checkCategoryById(id)

        }

        if (checkCategory == true) {

            this.setState({ loading: true })
            await Api.get(`/organizationcategories/withoutparents/${id}`)
                .then(async result => {


                    if (result.data.success) {
                        //await this.props.addCurrent(result.data.data)
                        this.setState({ loading: false })
                        await this.moveToAnotherPage(result.data.data, id)
                        //await this.componentDidMount();

                    }


                })
                .catch(err => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        const intl = this.props.intl;
                        this.setState({
                            loading: false,
                            openNotification: true,
                            notificationVariant: "error",
                            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                        });
                    }
                    else {
                        const intl = this.props.intl;
                        this.setState({
                            loading: false,
                            openNotification: true,
                            notificationVariant: "error",
                            notificationMessage: intl.formatMessage({ id: "process.error" })
                        });
                    }


                });

        }







    }

    handleChangeEditorDescription(value) {


        this.setState(prevState => ({
            called: {
                ...prevState.called,
                description: value
            }
        }));


    }

    moveToAnotherPage = async (nextElement, id) => {


        await this.props.addCurrent(nextElement);
        this.props.history.push({
            pathname: `/${this.props.match.params.lang}/portal-category/${nextElement.id}`,
            state: {
                action: "cardReload",
                parentId: nextElement.parentorganizationcategoryid
            }

        })

    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    getCategoryChildrens = async (parentId) => {

        this.setState({ loading: true })
        await Api.get(`/organizationcategories/childrensbyparent/${parentId}`)
            .then(async result => {
                if (result.data.success) {

                    this.setState({ loading: false, resultCategories: result.data.data })
                }

            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
                else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage: intl.formatMessage({ id: "process.error" })
                    });
                }


            });
    }

    getAllCategoryOfPortal = async () => {

        this.setState({ loading: true })
        await Api.get(`/organizationcategories/getallcategoryofportal`)
            .then(async result => {
                if (result.data.success) {

                    this.setState({ loading: false, resultCategoriesOfPortal: result.data.data })
                }

            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
                else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage: intl.formatMessage({ id: "process.error" })
                    });
                }


            });
    }


    getImage = async (AttachmentId) => {

        if (AttachmentId != null && AttachmentId != undefined) {
            var url = ""
            await Api.post(`/organizationcategories/attachments`, { AttachmentId })
                .then((result) => {


                    if (result.data) {
                        if (result.data.data && result.data.data.length != undefined && result.data.data.length != 0) {

                            url = result.data.data
                            this.setState({
                                urlImage: url
                            })

                            return result

                        }

                    }

                })
                .catch((err) => {
                    PapiroConsole.log(err);
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            err.response && err.response.data && err.response.data.errors
                                ? err.response.data.errors[0]
                                : this.props.intl.formatMessage({ id: "process.error" }),
                    });


                });

            return url

        }

    }
    handleChange(e, newValue) {


        this.setState({ tabvalue: newValue });

    }

    arraysEqual(arr1, arr2) {
        return JSON.stringify(arr1) === JSON.stringify(arr2);
    }

    getUnratedCalleds = async (page = 1) => {

        let idOrganization = null;
        let unratedCalledsList = []

        //let url = this.organizationId != null && this.organizationId > 0 ? `/calleds/classifications/organization/${this.organizationId}/user/${this.userid}/page/${page}` : `/calleds/classifications/all/${this.state.userId}/page/${page}`;
        
        let url = `/calleds/classifications/dapper/organization/${this.organizationId}/user/${this.userid}/page/${page}` ;
        this.setLoading(true)
        await Api.get(url)
            .then((result) => {
                if (result.data.success) {

                    result.data.data.forEach((element) => {
                        if (element != null) {
                            if (element.calledclassification == null) {
                                const exists = unratedCalledsList.some(newItem => newItem.id === element.id);
                                if (!exists) {
                                    unratedCalledsList.push({ ...element, displayassignedinfomode: this.displayassignedinfomode })
                                    this.idCalled = element.id;
                                    this.descriptionCalled = element.description;
                                    idOrganization = element.organizationid;
                                }
                                
                            }
                        }
                    });

                    PapiroConsole.log("unratedCalledsList aqui 1") 
                    PapiroConsole.log(unratedCalledsList)
                    PapiroConsole.log(this.state.unratedCalledsList)
                    //PapiroConsole.log(unratedCalledsList)

                    // const idsUnratedCalledsListState = new Set(this.state.unratedCalledsList.map(item => item.id));
                    // const filteredArray = unratedCalledsList && unratedCalledsList.length && unratedCalledsList.length > 0 ? unratedCalledsList.filter(item => !idsUnratedCalledsListState.has(item.id)) : [] ;

    
                    if(page > 1){
                        unratedCalledsList = [...this.state.unratedCalledsList, ...unratedCalledsList]
                    }
                    
                      
                    
                    this.setState({ unratedCalledsList: [...unratedCalledsList] })
                    if (unratedCalledsList.length !== 0) {
                        this.setState({ modalRatingOpen: unratedCalledsList.length !== 0 /*, 
                                        ratingModalWasOpen: true */
                         }, () => {
                            this.modalRating = <ModalRating
                                data={unratedCalledsList}
                                onClose={() => this.closeModalRating()}
                                requiredratingcalleds={this.requiredratingcalleds}
                                organizationId={this.organizationId}
                                createdUser={this.userid}
                                setLoading={this.setLoading}
                                setMessage={this.setMessage}
                                getFinishedCalleds={this.getUnratedCalleds}
                                showMore={result.data.data.length >= 10}
                                updateList={(newList) => this.setState({ unratedCalledsList: newList })}
                                adm={this.AdmOrganization}
                                originOfSurveyResponse = {1}
                            />
                        });
                    // } else {
                    //     this.setLoading( { ratingModalProcessed: true } );
                    //     this.tryToOpenRequesterModal();
                    }
                    this.setLoading(false)
                } else {
                    //console.log("=== getItens -> else ===")
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            result.data &&
                                result.data.response &&
                                result.data.response.data &&
                                result.data.response.data.errors &&
                                result.data.response.data.errors[0]
                                ? result.data.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    });
                    // this.setState({ ratingModalProcessed: true });
                    // this.tryToOpenRequesterModal();
                    Api.kickoff(result);

                }
            })
            .catch((err) => {
                PapiroConsole.log("=== getItens -> catch ===")
                PapiroConsole.log(err)
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response &&
                            err.response.data &&
                            err.response.data.errors &&
                            err.response.data.errors[0]
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(err);

            });
    }

    setLoading = (isLoad) => {
        this.setState({
            loading: isLoad
        })
    }

    setMessage = (open, variant, message) => {
        this.setState({
            openNotification: open,
            notificationVariant: variant,
            notificationMessage: message
        });
    }

    closeModalRating() {
        this.setState({
            modalRatingOpen: false,
            unratedCalledsList: [],
            ratingModalProcessed: true
        } /*,
            () => { this.tryToOpenRequesterModal() } */
        );
    }

    // cpfMask(value) {
    //     return value
    //         .replace(/\D/g, '')
    //         .replace(/(\d{3})(\d)/, '$1.$2')
    //         .replace(/(\d{3})(\d)/, '$1.$2')
    //         .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    //         .replace(/(-\d{2})\d+?$/, '$1');
    // }

    // CNPJMask(valor) {
    //     return valor
    //         .replace(/\D/g, '')
    //         .replace(/(\d{2})(\d)/, '$1.$2')
    //         .replace(/(\d{3})(\d)/, '$1.$2')
    //         .replace(/(\d{3})(\d)/, '$1/$2')
    //         .replace(/(\d{4})(\d{1,2})/, '$1-$2')
    //         .replace(/(-\d{2})\d+?$/, '$1');
    // }

    // isCPFOrCNPJValid(value) {
    //     const numericValue = value.replace(/\D/g, '');
        
    //     if (numericValue.length === 11) {
    //         let sum = 0;
    //         let remainder;
    //         for (let i = 1; i <= 9; i++) {
    //             sum += parseInt(numericValue.substring(i - 1, i)) * (11 - i);
    //         }
    //         remainder = (sum * 10) % 11;
    //         if (remainder === 10 || remainder === 11) remainder = 0;
    //         if (remainder !== parseInt(numericValue.substring(9, 10))) return false;
            
    //         sum = 0;
    //         for (let i = 1; i <= 10; i++) {
    //             sum += parseInt(numericValue.substring(i - 1, i)) * (12 - i);
    //         }
    //         remainder = (sum * 10) % 11;
    //         if (remainder === 10 || remainder === 11) remainder = 0;
    //         return remainder === parseInt(numericValue.substring(10, 11));
    //     } else if (numericValue.length === 14) {
    //         let tamanho = numericValue.length - 2;
    //         let numeros = numericValue.substring(0, tamanho);
    //         const digitos = numericValue.substring(tamanho);
    //         let soma = 0;
    //         let pos = tamanho - 7;
    //         for (let i = tamanho; i >= 1; i--) {
    //             soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
    //             if (pos < 2) pos = 9;
    //         }
    //         let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    //         if (resultado !== parseInt(digitos.charAt(0))) return false;
            
    //         tamanho = tamanho + 1;
    //         numeros = numericValue.substring(0, tamanho);
    //         soma = 0;
    //         pos = tamanho - 7;
    //         for (let i = tamanho; i >= 1; i--) {
    //             soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
    //             if (pos < 2) pos = 9;
    //         }
    //         resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    //         return resultado === parseInt(digitos.charAt(1));
    //     }
    //     return false;
    // }

    // handleInputChangeNewUser(e) {
    //     const name = e.target.name;
    //     const value = e.target.value;
        
    //     if (name === 'cpfOfNewUser') {
    //         let valor = value.length <= 14 ? this.cpfMask(value) : this.CNPJMask(value);
            
    //         if (valor.length === 0) {
    //             this.setState(prevState => ({ itemError: { ...prevState.itemError, document: 'Campo obrigatório' } }));
    //         } else if ((value.length !== 14 && value.length !== 18) || !this.isCPFOrCNPJValid(value)) {
    //             this.setState(prevState => ({ itemError: { ...prevState.itemError, document: 'CPF/CNPJ inválido' } }));
    //         } else {
    //             this.setState(prevState => ({ itemError: { ...prevState.itemError, document: '' } }));
    //         }
            
    //         this.setState(prevState => ({
    //             createUserCalled: { ...prevState.createUserCalled, [name]: valor }
    //         }));
    //     } else {
    //         this.setState(prevState => ({
    //             createUserCalled: { ...prevState.createUserCalled, [name]: value }
    //         }));
    //     }
    // }

    // resetNewUserForm() {
    //     this.setState({
    //         showNewUserForm: false,
    //         createUserCalled: {
    //             nameOfNewUser: null,
    //             cpfOfNewUser: null,
    //             emailOfNewUser: null,
    //             confirmEmailOfNewUser: null
    //         },
    //         OrganizationFilter: [],
    //         selectOrganizations: false,
    //         requestingUser: null,
    //         called: {
    //             ...this.state.called,
    //             requestingUser: null
    //         },
    //         requestingUserData: null,
    //         itemError: { document: '' }
    //     });
    // }

    // async getClientsByOrganizationId(orgId) {
    //     this.setState({ loadingClientUsers: true });
    //     const result = await CalledService.getClientsByOrganizationId(orgId);
    //     const intl = this.props.intl;
        
    //     if (result.success) {
    //         let reordernewarrayuserteclist = new Array();
    //         result.data.map(item => {
    //             item.name = item.name + " (" + item.email + ")";
    //             reordernewarrayuserteclist.push(item);
    //         });
    //         this.setState({ 
    //             loadingClientUsers: false, 
    //             clientUsersList: reordernewarrayuserteclist && reordernewarrayuserteclist.length > 1 
    //                 ? reordernewarrayuserteclist.sort((a, b) => a.name.localeCompare(b.name)) 
    //                 : reordernewarrayuserteclist 
    //         });
    //     } else {
    //         this.setState({
    //             loadingClientUsers: false,
    //             openNotification: true,
    //             notificationVariant: "error",
    //             notificationMessage: result.response?.data?.errors?.[0] || intl.formatMessage({ id: "process.error" })
    //         });
    //     }
    // }

    // async getOrganizations() {
    //     this.setState({ loading: true });
    //     let data = [];
    //     const { userSession } = this.props;
        
    //     if (userSession && userSession.user && userSession.user.userorganizations && userSession.user.userorganizations.length > 0) {
    //         data = userSession.user.userorganizations;
    //     } else {
    //         await Api.get('/organizations/tech')
    //             .then(result => { data = result.data.data; })
    //             .catch(err => { data = err; });
    //     }
    //     this.setState({ organizationList: data, loading: false });
    // }

    // async goToCalled(user) {
    //     console.log("user selecionado --> ", user);
    //     const selectedUser = user.id !== this.props.userSession.user.id ? user.id : this.props.userSession.user.id;
        
    //     const formattedUser = {
    //         ...user,
    //         formattedName: !this.state.selectedUser ? `${user.name} (${user.email})` : user.name
    //     };
        
    //     this.setState({ 
    //         requestingUser: selectedUser,
    //         requestingUserData: { ...this.state.requestingUserData, name: formattedUser.formattedName },
    //         selectRequesterDialog: false 
    //     });        
    //     this.showNotification("success", "Usuário selecionado com sucesso!"); 
    // }

    // handleRequesterSelection = async () => {
    //     const { requesterOption, selectedUser, showNewUserForm } = this.state;
    //     const loggedUser = this.props.userSession.user;

    //     if (showNewUserForm) {
    //         const { nameOfNewUser, cpfOfNewUser, emailOfNewUser, confirmEmailOfNewUser } = this.state.createUserCalled;
            
    //         if (!nameOfNewUser) {
    //             this.showNotification("error", "Nome é obrigatório");
    //             return;
    //         }
    //         if (!cpfOfNewUser || !this.isCPFOrCNPJValid(cpfOfNewUser)) {
    //             this.showNotification("error", "CPF/CNPJ inválido");
    //             return;
    //         }
    //         if (!emailOfNewUser) {
    //             this.showNotification("error", "Email é obrigatório");
    //             return;
    //         }
    //         if (emailOfNewUser !== confirmEmailOfNewUser) {
    //             this.showNotification("error", "Emails não conferem");
    //             return;
    //         }

    //         let config = {
    //             headers: {
    //                 "Content-Type": "multipart/form-data",
    //             },
    //         };

    //         let data = new FormData();
    //         for (let key in this.state.createUserCalled) {
    //             if(key == "nameOfNewUser"){
    //                 data.append("username", this.state.createUserCalled[key])
    //             }
    //             else if(key == "cpfOfNewUser"){
    //                 data.append("userdocument", this.state.createUserCalled[key])
    //             }
    //             else if(key == "emailOfNewUser"){
    //                 data.append("useremail", this.state.createUserCalled[key])
    //             }
    //             else if(key == "confirmEmailOfNewUser"){
    //                 data.append("userconfirmemail", this.state.createUserCalled[key])
    //             }
    //         }

    //         if(this.state.associateOrganizationOptions == 'associateOtherOrganizations'){
    //             const organizationsIds = this.state.OrganizationFilter.map(item => item.id);
    //             const organizationsIdsString = organizationsIds.join(',');
    //             data.append("AssociateOrganizationOption", 2)
    //             data.append("SelectedOrganizations",organizationsIdsString)
    //         }
    //         else{
    //             data.append("AssociateOrganizationOption", 2); 
    //             data.append("SelectedOrganizations", this.state.selectedOrganizationForRequester ? this.state.selectedOrganizationForRequester.id : '');
    //         }
            
    //         data.append("OrganizationId", this.state.organizationCategory.organizationId)
    //         data.append("CreatedAt", this.state.createdAt)
    //         data.append("CreatedUser", this.state.called.createdUser)
            
    //         try {
    //             this.setState({ loading: true });
    //             await Api.post("/users/create-user-called", data, config)
    //                 .then(async response => {
    //                     if (response.data && response.data.success) {
    //                         const newUser = response.data.data;
    //                         this.setState({ selectRequesterDialog: false, loading: false });
    //                         await this.goToCalled(newUser);
    //                     } else {
    //                         this.showNotification("error", "Erro ao criar usuário");
    //                         this.setState({ loading: false });
    //                     }
    //                 }).catch(err => {
        
    //                     if (err.response && err.response.data && err.response.data.errors) {
    //                         const intl = this.props.intl;
    //                         this.showNotification("error", err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }));                            
    //                     }else {
    //                         const intl = this.props.intl;
    //                         this.showNotification("error", intl.formatMessage({ id: "process.error" }));                            
                        
    //                     }
    //                 });

    //         } catch (error) {
    //             this.showNotification("error", "Erro ao criar usuário");
    //             this.setState({ loading: false });
    //         }
    //     } else {
    //         if (requesterOption === 'other' && !selectedUser) {
    //             this.showNotification("error", "Selecione um solicitante");
    //             return;
    //         }
            
    //         const userToSend = requesterOption === 'me' ? loggedUser : selectedUser;
    //         this.setState({ selectRequesterDialog: false });
    //         await this.goToCalled(userToSend);
    //     }
    // }


    // tryToOpenRequesterModal() {
    //     if (!this.state.ratingModalProcessed) {
    //         return;
    //     }        
        
    //     const isFinalCategory = this.state.organizationCategory.canCreateCalled == true && 
    //                             this.state.resultCategories.length == 0;
        
    //     let isClient = this.isClient;
        
    //     if (isFinalCategory && !isClient && this.state.ratingModalProcessed) {
    //         this.setState({
    //             selectRequesterDialog: true,
    //             selectedCategory: this.state.organizationCategory,
    //             showNewUserForm: false,
    //             requesterOption: 'me',
    //             selectedOrganizationForRequester: null,
    //             selectedUser: null,
    //             clientUsersList: []
    //         });
    //     }
    // }
    
    // showNotification(variant, message) {
    //     this.setState({
    //         openNotification: true,
    //         notificationVariant: variant,
    //         notificationMessage: message
    //     });
    //     setTimeout(() => this.setState({ openNotification: false }), 5000);
    // }

    render() {
        const { classes } = this.props;
        const intl = this.props.intl;
        const { called } = this.state;

        if (this.state.modalRatingOpen === false) {
            this.modalRating = null;
          }

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }


        // const modalRequestingUser = 
        //     <Dialog 
        //         open={this.state.selectRequesterDialog}
        //         onClose={() => {
        //             this.setState({ selectRequesterDialog: false });
        //             this.resetNewUserForm();
        //         }}
        //         maxWidth="md"
        //         fullWidth
        //     >
        //         <DialogTitle>Quem é o solicitante?</DialogTitle>

        //         <DialogContent>
        //             <RadioGroup
        //                 value={this.state.requesterOption}
        //                 onChange={(e) => {
        //                     this.setState({ 
        //                         requesterOption: e.target.value,
        //                         showNewUserForm: false,
        //                         selectedOrganizationForRequester: null,
        //                         selectedUser: null,
        //                         clientUsersList: []
        //                     });
        //                 }}
        //             >
        //                 <FormControlLabel value="me" control={<Radio />} label="Eu sou o solicitante" />
        //                 <FormControlLabel value="other" control={<Radio />} label="Vou escolher outro solicitante" />
        //             </RadioGroup>

        //             {this.state.requesterOption === 'other' && (
        //                 <>
        //                     <div style={{ marginTop: 15 }}>
        //                         <SimpleAutoComplete 
        //                             label={intl.formatMessage({ id: "organization" })} 
        //                             options={this.state.organizationList} 
        //                             stateName="organizationForRequester"
        //                             changeSelect={(stateName, value) => {
        //                                 this.changeValues(stateName, value, "");
        //                             }}
        //                             selected={this.state.selectedOrganizationForRequester} 
        //                             isRequired 
        //                             required 
        //                         />
        //                     </div>

        //                     {this.state.selectedOrganizationForRequester && (
        //                         <>
        //                             {!this.state.showNewUserForm ? (
        //                                 <div style={{ marginTop: 15 }}>
        //                                     {this.state.loadingClientUsers ? (
        //                                         <div style={{ textAlign: 'center', marginTop: 20 }}>
        //                                             <CircularProgress size={30} />
        //                                         </div>
        //                                     ) : (
        //                                         <>
        //                                             <SimpleAutoComplete
        //                                                 label="Selecionar solicitante"
        //                                                 options={this.state.clientUsersList.map(user => ({
        //                                                     id: user.id,
        //                                                     name: `${user.name}`
        //                                                 }))}
        //                                                 stateName="selectedUser"
        //                                                 changeSelect={this.changeValues}
        //                                                 selected={this.state.selectedUser}
        //                                                 fullWidth
        //                                             />
                                                    
        //                                             {this.state.clientUsersList.length === 0 && (
        //                                                 <Typography variant="body2" color="textSecondary" style={{ marginTop: 10, textAlign: 'center' }}>
        //                                                     Nenhum usuário encontrado nesta organização
        //                                                 </Typography>
        //                                             )}
                                                    
        //                                             <div style={{ marginTop: 15, textAlign: 'center' }}>
        //                                                 <Button 
        //                                                     color="primary"
        //                                                     onClick={() => this.setState({ showNewUserForm: true })}
        //                                                 >
        //                                                     + Cadastrar novo solicitante
        //                                                 </Button>
        //                                             </div>
        //                                         </>
        //                                     )}
        //                                 </div>
        //                             ) : (
        //                                 <>
        //                                     <div style={{ textAlign: 'right', marginBottom: 10 }}>
        //                                         <Button 
        //                                             size="small"
        //                                             onClick={() => this.resetNewUserForm()}
        //                                         >
        //                                             ← Voltar para lista
        //                                         </Button>
        //                                     </div>
                                            
        //                                     <Grid container spacing={2} style={{ marginTop: 5 }}>
        //                                         <Grid item xs={12} sm={6}>
        //                                             <TextField 
        //                                                 fullWidth 
        //                                                 label={`${intl.formatMessage({id:"name"})}*`} 
        //                                                 inputProps={{ maxLength: 255 }} 
        //                                                 variant='outlined' 
        //                                                 name='nameOfNewUser' 
        //                                                 onChange={this.handleInputChangeNewUser.bind(this)}  
        //                                             />
        //                                         </Grid>
        //                                         <Grid item xs={12} sm={6}>
        //                                             <TextField  
        //                                                 name="cpfOfNewUser"
        //                                                 label="CPF/CNPJ*"
        //                                                 fullWidth
        //                                                 value={this.state.createUserCalled.cpfOfNewUser}
        //                                                 onChange={this.handleInputChangeNewUser.bind(this)}
        //                                                 InputLabelProps={{ shrink: true }}
        //                                                 error={this.state.itemError?.document?.length > 0}
        //                                                 helperText={this.state.itemError?.document}
        //                                             />
        //                                         </Grid>
        //                                         <Grid item xs={12} sm={6}>
        //                                             <TextField 
        //                                                 fullWidth 
        //                                                 label={`${intl.formatMessage({id:"email"})}*`} 
        //                                                 inputProps={{ maxLength: 255 }} 
        //                                                 variant='outlined' 
        //                                                 name='emailOfNewUser' 
        //                                                 onChange={this.handleInputChangeNewUser.bind(this)}  
        //                                             />
        //                                         </Grid>
        //                                         <Grid item xs={12} sm={6}>
        //                                             <TextField 
        //                                                 fullWidth 
        //                                                 label={`${intl.formatMessage({id:"confirm.email"})}*`} 
        //                                                 inputProps={{ maxLength: 255 }} 
        //                                                 variant='outlined' 
        //                                                 name='confirmEmailOfNewUser' 
        //                                                 onChange={this.handleInputChangeNewUser.bind(this)}  
        //                                             />
        //                                         </Grid>

        //                                         <Grid item xs={12}>
        //                                             <FormControl>
        //                                                 <FormLabel id="demo-controlled-radio-buttons-group">{intl.formatMessage({id:"associate.organizations"})}</FormLabel>
        //                                                 <RadioGroup
        //                                                     aria-labelledby="demo-controlled-radio-buttons-group"
        //                                                     name="controlled-radio-buttons-group"
        //                                                     value={this.state.associateOrganizationOptions}
        //                                                     onChange={(e) => {
        //                                                         const value = e.target.value;
        //                                                         this.setState({ 
        //                                                             associateOrganizationOptions: value,
        //                                                             OrganizationFilter: value === 'associateSelectedOrganization' ? [] : this.state.OrganizationFilter,
        //                                                             selectOrganizations: value === 'associateSelectedOrganization' ? false : this.state.selectOrganizations
        //                                                         });
        //                                                     }}
        //                                                 >
        //                                                     <FormControlLabel value="associateSelectedOrganization" control={<Radio />} label={intl.formatMessage({id:"associate.requesting.user.to.selected.organization"})} />
        //                                                     <FormControlLabel value="associateOtherOrganizations" control={<Radio />} label={intl.formatMessage({id:"associate.requesting.user.to.others.organizations"})} />
        //                                                 </RadioGroup>
        //                                             </FormControl>
        //                                             {this.state.associateOrganizationOptions == 'associateOtherOrganizations' && 
        //                                                 <>                                                        
        //                                                 <Typography variant="body2" color="textSecondary" gutterBottom>
        //                                                     Organização pré-selecionada: {this.state.selectedOrganizationForRequester?.name}
        //                                                 </Typography>
        //                                                 <SimpleAutoCompleteMultiple 
        //                                                     label={intl.formatMessage({ id: "organization" })} 
        //                                                     options={this.state.organizationList} 
        //                                                     stateName='OrganizationFilter' 
        //                                                     changeSelect={this.changeValues} 
        //                                                     selected={this.state.OrganizationFilter}
        //                                                     placeholder="Ou selecione outras organizações (opcional)"
        //                                                 />
        //                                                  <Grid item xs={12}>
        //                                                     <SimpleCheckBox 
        //                                                         label={intl.formatMessage({ id: "technical.team.edit.select.all.organizations" })} 
        //                                                         name='selectOrganizations' 
        //                                                         stateName='selectOrganizations' 
        //                                                         changeSelect={this.changeValues} 
        //                                                         selected={this.state.selectOrganizations} 
        //                                                     />
        //                                                 </Grid>
        //                                                 </>
        //                                             }
                                                    
        //                                         </Grid>
        //                                     </Grid>
        //                                 </>
        //                             )}
        //                         </>
        //                     )}
        //                 </>
        //             )}
        //         </DialogContent>

        //         <DialogActions>
        //             {/* <Button onClick={() => {
        //                 this.setState({ selectRequesterDialog: false });
        //                 this.resetNewUserForm();
        //             }}>
        //                 Cancelar
        //             </Button> */}

        //             <Button 
        //                 onClick={this.handleRequesterSelection.bind(this)} 
        //                 color="primary"
        //                 variant="contained"
        //                 disabled={
        //                     this.state.requesterOption === 'other' && 
        //                     !this.state.selectedOrganizationForRequester
        //                 }
        //             >
        //                 {this.state.showNewUserForm ? "Cadastrar e continuar" : "Continuar"}
        //             </Button>
        //         </DialogActions>
        //     </Dialog>

        return (
            <Container component='main' maxWidth='lg'>
                {this.modalRating}
                {(this.state.informativeText != null && this.state.informativeText.length > 0) && <Accordion expanded={this.state.informativeTextAccordionExpanded} onChange={this.handleChangeAccordion("informative-text")} sx={{
                    width: '30%',
                    position: 'fixed',
                    top: '15%',
                    right: '2%',
                    zIndex: '80'
                }}>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="informative-text-content"
                        id="informative-text-header">
                        <Typography>Informativo</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Paper elevation={3} >
                            <Grid container spacing={0}>
                                <Grid item xs={1} sm={1} style={{ backgroundColor: '#f7f2a9' }}></Grid>
                                <Grid item xs={11} sm={11} style={{ padding: '25px 25px 25px 20px' }}>
                                    <Grid container spacing={0}>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="body1">
                                                <div dangerouslySetInnerHTML={{ __html: this.state.informativeText }} />
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </AccordionDetails>
                </Accordion>}
                <CssBaseline />

                <div className={classes.paper} style={{ marginTop: 0 }}>
                    <Dialog
                        open={this.state.calledInfoDialogOpen}
                        onClose={this.closeCalledInfoDialog}
                        aria-labelledby="form-delete-filter"
                        maxWidth="md"
                        fullWidth={false}
                        style={{ overflow: 'hidden' }}
                        scroll="body" >
                        <DialogTitle id="form-delete-filter">Chamado criado com sucesso!</DialogTitle>
                        <DialogContent style={{ minWidth: "400px" }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="body1" component="span" className={this.props.class} style={{ fontWeight: 'bold' }}>
                                        Número do chamado:&nbsp;
                                    </Typography>
                                    <Typography variant="body1" component="span" className={this.props.class}>
                                        {this.state.calledInfoDialogId}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="body1" component="span" className={this.props.class} style={{ fontWeight: 'bold' }}>
                                        Título do chamado:&nbsp;
                                    </Typography>
                                    <Typography variant="body1" component="span" className={this.props.class}>
                                        {this.state.calledInfoDialogTitle}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="body1" component="span" className={this.props.class} style={{ fontWeight: 'bold' }}>
                                        Data de previsão de solução:&nbsp;
                                    </Typography>
                                    <Typography variant="body1" component="span" className={this.props.class}>
                                        {this.state.calledInfoDialogDueDate}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.closeCalledInfoDialog} color="primary">
                                {intl.formatMessage({ id: "close" })}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Grid container spacing={6} style={{ marginBottom: 15 }}>
                        <Grid item xs={12} sm={4}>
                            <Button variant='outlined' color='primary' onClick={() => {
                                this.backHistory()
                            }
                            }>{<FormattedMessage id="back" />}</Button>
                        </Grid>
                        <Grid item xs={12} sm={8} />
                    </Grid>

                    <Grid container spacing={6} style={{ marginBottom: 15 }}>
                        <Grid item xs={12} sm={12}>
                            <Card className="background-title-search">
                                <CardContent>
                                    <Grid container >
                                        <Grid container >
                                            <Grid item xs={12}>
                                                <Typography variant="h5">
                                                    {<FormattedMessage id="portal" />}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container style={{ marginTop: 10 }} >
                                            <Grid item xs={12} >

                                                <SimpleAutoComplete label={intl.formatMessage({ id: "categories" })} options={this.state.resultCategoriesOfPortal} stateName='searchCategories' changeSelect={this.changeValues} />
                                            </Grid>

                                        </Grid>


                                    </Grid>

                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                    <Grid container spacing={6} style={{ marginBottom: 15 }}>
                        <Grid item xs={12} sm={12}>
                            <Card >
                                <CardContent>
                                    <Grid container >
                                        <Grid item xs={2}>
                                            {this.state.urlImage != null

                                                ?
                                                <CardMedia
                                                    component="img"
                                                    height="194"
                                                    sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                                    src={`${this.state.urlImage}`}

                                                />

                                                : null

                                            }

                                        </Grid>

                                        <Grid item xs={8} style={{ padding: 16 }}>

                                            <Typography gutterBottom variant="h3" component="div">
                                                {this.state.organizationCategory.parentName != "" && this.state.organizationCategory.parentName != null
                                                    ? this.state.organizationCategory.parentName
                                                    : this.state.organizationCategory.name
                                                }
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                <div dangerouslySetInnerHTML={{ __html: this.state.organizationCategory.description }} />

                                            </Typography>
                                        </Grid>

                                    </Grid>


                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>



                    {this.state.organizationCategory.canCreateCalled == true && this.state.resultCategories.length == 0 ?


                        <Grid container spacing={2} component="main" >


                            <Grid item xs={4} ></Grid>
                            <Grid item xs={4} align="center">
                                <Avatar className={classes.avatar}>
                                    <QueuePlayNext />
                                </Avatar>
                                <Typography component="h1" variant="h5" textAlign="center">
                                    {<FormattedMessage id="called.new" />}
                                </Typography>

                            </Grid>
                            <Grid item xs={4}></Grid>
                            {(this.state.organizationCategory != null && this.state.organizationCategory.information != null && this.state.organizationCategory.information.length > 0) && <Grid item xs={12} sm={12} style={{ marginBottom: "5px" }}>
                                <Typography variant="h4">
                                    <FormattedMessage id="category.infomation" />
                                </Typography>
                            </Grid>}
                            {(this.state.organizationCategory != null && this.state.organizationCategory.information != null && this.state.organizationCategory.information.length > 0) && <Grid item xs={12} sm={12} >
                                <Typography variant="body1" component="span" className={this.props.class} style={{ fontWeight: 'bold', }}>
                                    <div dangerouslySetInnerHTML={{ __html: this.state.organizationCategory.information }} />
                                </Typography>
                            </Grid>}

                            <form
                                name="myForm"

                                onSubmit={this.handleSubmit}
                                encType="multipart/form-data"
                            >
                                <Grid container spacing={2} style={{ marginLeft: "1px" }} >
                                    <Grid item xs={12} sm={12} >
                                        <If test={this.state.organizationFieldList && this.state.organizationFieldList.length > 0} >
                                            <Grid item xs={12} sm={12}>
                                                <fieldset style={{
                                                    marginTop: 25,
                                                    marginBottom: 25,
                                                    border: '1px solid #c0c0c0',
                                                    padding: '0 0 15px 0',
                                                    borderLeft: 'none',
                                                    borderRight: 'none'
                                                }}>
                                                    <legend style={{
                                                        paddingTop: 15,

                                                        fontSize: '1.3rem',
                                                        border: '1px solid #c0c0c0',
                                                        borderBottom: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none'
                                                    }}>{intl.formatMessage({ id: "organization.custom.fields" })}</legend>
                                                    <Grid container spacing={2} style={{ marginBottom: "25px" }}>
                                                        {this.state.campoTexto}
                                                    </Grid>
                                                </fieldset>
                                            </Grid>
                                        </If>

                                    </Grid>
                                    {/* {!this.isClient && (
                                        <Grid item xs={12} sm={12}>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                label={intl.formatMessage({ id: "modalRating.called.requesting.user" })}
                                                value={this.state.requestingUserData ? 
                                                    this.state.requestingUserData.name : 
                                                    ""}
                                                placeholder="Clique para selecionar o solicitante"
                                                onClick={() => this.tryToOpenRequesterModal()}
                                                InputProps={{
                                                    readOnly: true,
                                                    sx: {
                                                        cursor: 'pointer',
                                                        backgroundColor: this.state.requestingUserData ? '#f5f5f5' : 'white'
                                                    }
                                                }}
                                                helperText={!this.state.requestingUserData ? 
                                                    "Clique para selecionar o solicitante" : 
                                                    "Clique para alterar o solicitante"}
                                            />
                                        </Grid>
                                    )} */}
                                    <Grid item xs={12} sm={12} >
                                        <TextField
                                            autoComplete="fname"
                                            name="title"
                                            variant="outlined"
                                            fullWidth
                                            id="title"
                                            label={intl.formatMessage({ id: "title" })}
                                            value={called.title ? called.title : ""}
                                            onChange={this.handleInputChange}
                                            inputProps={{ maxLength: 250 }}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} style={{ marginBottom: "25px" }} >

                                        <Typography>
                                            <FormattedMessage id="description" />*
                                        </Typography>
                                        <ReactQuill name="description" value={called.description} style={{ height: 200 }}
                                            modules={this.reactQuillModules}
                                            formats={this.reactQuillFormats}
                                            fullWidth
                                            required
                                            variant="outlined"
                                            id="outlined-multiline-static"
                                            onChange={this.handleChangeEditorDescription} />
                                    </Grid>

                                    <Grid item xs={12} sm={12} mt={3}  >
                                        <Typography variant="h6" gutterBottom >
                                            <FormattedMessage id="attach.your.files" />
                                        </Typography>
                                        <section style={{ width: "100%", marginTop: '8px' }}>
                                            <div className={classes.dropzoneArea} style={{ minHeight: '70px', marginTop: '5px ' }}>
                                                <Dropzone
                                                    onDrop={(acceptedFiles) => {
                                                        this.setState({ files: [...acceptedFiles, ...this.state.files] });
                                                    }}
                                                >
                                                    {({ getRootProps, getInputProps, acceptedFiles }) => (
                                                        <div {...getRootProps()}>
                                                            <input {...getInputProps()} />
                                                            <AttachFileIcon />
                                                            <Typography component="span" fontWeight="bold" fontSize={16} color="gray">
                                                                <FormattedMessage id="drag.and.drop.files" />
                                                            </Typography>
                                                        </div>
                                                    )}
                                                </Dropzone>
                                                {this.state.files.map((file) => {
                                                    return (
                                                        <div className={classes.dropzoneItem} key={file.name}>
                                                            {file.name}
                                                            <DeleteForever
                                                                className={classes.deleteItem}
                                                                onClick={() => {
                                                                    this.removeItem(file);
                                                                }}
                                                            />
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </section>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Grid container justify="flex-end" style={{ justifyContent: 'flex-end', marginBottom: '10px' }}  >
                                            <Grid item xs={12} sm={3} style={{ justifyContent: 'flex-end' }}>
                                                <Button
                                                    type="submit"
                                                    fullWidth
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.submit}
                                                //onClick={this.handleSubmit}
                                                //disabled={this.state.disabledSaveButton}
                                                >
                                                    {<FormattedMessage id="save" />}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>

                            </form>





                        </Grid>


                        :

                        <Grid container spacing={6} style={{ marginTop: 15, marginLeft: "33px" }}>

                            <Tabs value={this.state.tabvalue} onChange={this.handleChange} aria-label="icon label tabs example">
                                <Tab icon={<CategoryIcon />} label="Serviços" />



                            </Tabs>

                            <Grid container spacing={2} style={{ marginTop: 10 }} >


                                {this.state.resultCategories.map((element) => {
                                    return (

                                        <Cardcategories actualElement={this.state.organizationCategory.id} key={element.id} properties={this.props} element={element} maxLength={150} />



                                    );
                                })}


                            </Grid>

                        </Grid>




                    }






                </div>




                <Dialog
                    open={this.state.openDialogNewAttendence}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{intl.formatMessage({id:"dialog.title.warning.max.attendances.reached"})}</DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {intl.formatMessage({id:"warning.max.attendances.reached.first.half"})} R$ {this.state.valueNewAttendence} {intl.formatMessage({id:"warning.max.attendances.reached.second.half"})}
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={this.openDialogNewAttendence} variant="contained" color="secondary" autoFocus >
                        {intl.formatMessage({id:"cancel"})}
                    </Button>
                    <Button variant="contained" onClick={this.handleSubmitAccept} color="primary" >
                    {intl.formatMessage({id:"accept"})}
                    </Button>
                    </DialogActions>
                </Dialog>


                {/* { modalRequestingUser } */}

                {this.state.loading && (
                    <Overlay>
                        <CircularProgress color='secondary' />
                    </Overlay>
                )}


                <CustomizedSnackbars
                    variant={this.state.notificationVariant}
                    message={this.state.notificationMessage}
                    isOpen={this.state.openNotification}
                    toClose={this.closeNotification}
                />


            </Container>
        );
    }
}
CardInformations.propTypes = {
    classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
    organizations: state.organizations,
    organizationcategoryportal: state.organizationcategoryportal
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);
export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(CardInformations))));
CardInformations.contextType = AbilityContext;
